<form [formGroup]="licenseForm">
  <div class="row">
    <div class="column">
      <mat-form-field appearance="outline" class="row input-with-icon">
        <mat-label>Department of Business and Professional Regulation License Number</mat-label>
        <input formControlName="licenseNumber" matInput>
        <mat-icon matSuffix svgIcon="exclamation-icon"
          matTooltip="Florida State Business License (FORM: #DBPR HR-7028) for further information contact the DBPR at 850-487-1395." />
      </mat-form-field>


      <mat-card class="row certificate-container" appearance="outlined">
        <h5 class="column">Provide one of these fields in order to submit your property</h5>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Florida State Department of Revenue Sales Tax Certificate Number</mat-label>
          <input formControlName="taxNumber" matInput (blur)="onTaxNumberBlur()">
        </mat-form-field>
        <mat-checkbox formControlName="appliedFor" class="certificate-checkbox">State Certificate has been applied
          for <mat-icon matSuffix svgIcon="exclamation-icon"
            matTooltip="Each rental property must be registered with the Florida Department of Revenue for state sales tax purposes. If you have not yet received your certificate number please indicate in the 'applied for' checkbox above. For further information contact the Florida Department of Revenue at 941-343-0201 or https://floridarevenue.com." /></mat-checkbox>
        <mat-form-field appearance="outline" class="column">
          <mat-label>If the property has not been registered, please state the reason why</mat-label>
          <input formControlName="notRegisteredReason" matInput>
        </mat-form-field>
      </mat-card>
    </div>
    <div class="column">
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact First Name</mat-label>
          <input matInput formControlName="primaryContactFirstName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact Last Name</mat-label>
          <input matInput formControlName="primaryContactLastName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact Email Address</mat-label>
          <input matInput formControlName="primaryContactEmail">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact Phone Number</mat-label>
          <input matInput formControlName="primaryContactPhoneNumber">
          <mat-error *ngIf="licenseForm.get('primaryContactPhoneNumber')?.hasError('required')">
            Phone Number is required.
          </mat-error>
          <mat-error *ngIf="licenseForm.get('primaryContactPhoneNumber')?.hasError('pattern')">
            Please use a valid phone number.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
